import { observer } from 'mobx-react-lite'
import { useFrame, useThree } from '@react-three/fiber'
import { useEffect, useRef } from 'react'
import { FlyControls } from 'three/examples/jsm/controls/FlyControls.js'
import { store } from '@/src/stores/store'

export const DebugFlyCameraControls = observer(function DebugFlyCameraControls() {
    const camera = useThree((state) => state.camera)
    const gl = useThree((state) => state.gl)
    const controlsRef = useRef<FlyControls | null>(null)
    const enabled = store.debugFreeFlyCameraEnabled

    useEffect(() => {
        if (!enabled) {
            controlsRef.current?.dispose()
            controlsRef.current = null
            return
        }

        const controls = new FlyControls(camera, gl.domElement)
        controls.movementSpeed = 20
        controls.rollSpeed = Math.PI / 8
        controls.dragToLook = true
        controls.autoForward = false
        controlsRef.current = controls

        return () => {
            controls.dispose()
            if (controlsRef.current === controls) {
                controlsRef.current = null
            }
        }
    }, [camera, enabled, gl])

    useFrame((_, delta) => {
        if (!enabled) {
            return
        }

        controlsRef.current?.update(delta)
    })

    return null
})
